module.exports = __webpack_public_path__ + "img/m-workbench.feb0b583.svg";